// src/api/enterprise.js
import { fetchWithAuth } from "./fetchWithAuth";

const API_URL = 'http://qcan-dev.smart-era.com:8001/cl/v1/';

export const getEnterprise = async (id) => {
  return await fetchWithAuth(`${API_URL}enterprise/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getDivisions = async (enterpriseId) => {
  if (!enterpriseId) throw new Error("Enterprise ID is required");
  return await fetchWithAuth(`${API_URL}division?enterprise_id=${enterpriseId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const createDivision = async (enterpriseId, name, timezone) => {
  return await fetchWithAuth(`${API_URL}division`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      enterprise_id: enterpriseId,
      name,
      timezone,
    }),
  });
};

export const getDivisionDetails = async (divisionId) => {
  if (!divisionId) throw new Error("Division ID is required");
  return await fetchWithAuth(`${API_URL}division/${divisionId}/`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const updateDivision = async (divisionId, name, timezone) => {
  return await fetchWithAuth(`${API_URL}division/${divisionId}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      name,
      timezone,
    }),
  });
};

export const deleteDivision = async (divisionId) => {
  return await fetchWithAuth(`${API_URL}division/${divisionId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getTimezones = async () => {
  return await fetchWithAuth(`${API_URL}division/timezones`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getNomenclature = async (enterpriseId) => {
  return await fetchWithAuth(`${API_URL}nomenclature?enterprise_id=${enterpriseId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const createNomenclature = async (enterpriseId, name) => {
  return await fetchWithAuth(`${API_URL}nomenclature`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ enterprise_id: enterpriseId, name }),
  });
};

export const updateNomenclatureName = async (nomenclatureId, name) => {
  return await fetchWithAuth(`${API_URL}nomenclature/${nomenclatureId}/name`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ name }),
  });
};

export const deleteNomenclature = async (nomenclatureId) => {
  return await fetchWithAuth(`${API_URL}nomenclature/${nomenclatureId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getEquipmentGroup = async (divisionId) => {
  return await fetchWithAuth(`${API_URL}equipment-group?division_id=${divisionId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const createEquipmentGroup = async (divisionId, name, equipmentIds = []) => {
  return await fetchWithAuth(`${API_URL}equipment-group`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      division_id: divisionId,
      name,
      equipment_list: equipmentIds,
    }),
  });
};

export const updateEquipmentGroupName = async (groupId, name) => {
  return await fetchWithAuth(`${API_URL}equipment-group/${groupId}/name`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ name }),
  });
};

export const deleteEquipmentGroup = async (groupId) => {
  return await fetchWithAuth(`${API_URL}equipment-group/${groupId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getEquipmentInGroup = async (groupId) => {
  return await fetchWithAuth(`${API_URL}equipment-group/${groupId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getEquipment = async (divisionId) => {
  return await fetchWithAuth(`${API_URL}equipment?division_id=${divisionId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const createEquipment = async (divisionId, name, status, description, groupIds = []) => {
  return await fetchWithAuth(`${API_URL}equipment`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      division_id: divisionId,
      name,
      status,
      description,
      equipment_groups: groupIds,
    }),
  });
};

export const updateEquipment = async (equipmentId, name, status, description) => {
  return await fetchWithAuth(`${API_URL}equipment/${equipmentId}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      name,
      status,
      description,
    }),
  });
};

export const deleteEquipment = async (equipmentId) => {
  return await fetchWithAuth(`${API_URL}equipment/${equipmentId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getTechnologicalCards = async (divisionId) => {
  return await fetchWithAuth(`${API_URL}product-sheet?division_id=${divisionId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const createTechnologicalCard = async (divisionId, name, selectedNomenclatureId) => {
  return await fetchWithAuth(`${API_URL}product-sheet`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      division_id: divisionId,
      name,
      nomenclature_id: selectedNomenclatureId,
    }),
  });
};

export const updateTechnologicalCard = async (id, name, nomenclatureId) => {
  return await fetchWithAuth(`${API_URL}product-sheet/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      name,
      nomenclature_id: nomenclatureId,
    }),
  });
};

export const updateTechnologicalCardName = async (cardId, name) => {
  return await fetchWithAuth(`${API_URL}product-sheet/${cardId}/name`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ name }),
  });
};

export const deleteTechnologicalCard = async (cardId) => {
  return await fetchWithAuth(`${API_URL}product-sheet/${cardId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const updateEquipmentGroupEquipment = async (groupId, equipmentIds) => {
  return await fetchWithAuth(`${API_URL}equipment-group/${groupId}/equipment`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ equipment_list: equipmentIds }),
  });
};

export const getEquipmentGroups = async (divisionId) => {
  return await fetchWithAuth(`${API_URL}equipment-group?division_id=${divisionId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getGroupsForEquipment = async (equipmentId) => {
  return await fetchWithAuth(`${API_URL}equipment/${equipmentId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const updateEquipmentGroups = async (equipmentId, groupIds) => {
  return await fetchWithAuth(`${API_URL}equipment/${equipmentId}/groups`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ equipment_groups: groupIds }),
  });
};

export const getOrders = async (divisionId) => {
  return await fetchWithAuth(`${API_URL}orders?division_id=${divisionId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const createOrder = async (divisionId, name, orderItems) => {
  return await fetchWithAuth(`${API_URL}order`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      division_id: divisionId,
      name,
      order_items: orderItems,
    }),
  });
};

export const updateOrderName = async (orderId, name) => {
  return await fetchWithAuth(`${API_URL}order/${orderId}/name`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ name }),
  });
};

export const deleteOrder = async (orderId) => {
  return await fetchWithAuth(`${API_URL}order/${orderId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getOrderDetails = async (orderId) => {
  return await fetchWithAuth(`${API_URL}order/${orderId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const createOrderItem = async (orderId, nomenclatureId, quantity) => {
  return await fetchWithAuth(`${API_URL}order-item`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      order_id: orderId,
      nomenclature_id: nomenclatureId,
      quantity,
    }),
  });
};

export const updateOrderItemQuantity = async (itemId, quantity) => {
  return await fetchWithAuth(`${API_URL}order-item/${itemId}/nomenclature-quantity`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ quantity }),
  });
};

export const deleteOrderItem = async (itemId) => {
  return await fetchWithAuth(`${API_URL}order-item/${itemId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getNomenclatures = async (enterpriseId) => {
  return await fetchWithAuth(`${API_URL}nomenclature?enterprise_id=${enterpriseId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const upsertOrder = async (divisionId, orderId, name, orderItems) => {
  return await fetchWithAuth(`${API_URL}order/upsert`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      division_id: divisionId,
      order_id: orderId || null,
      order_name: name,
      order_items: orderItems.map((item) => ({
        order_item_id: item.order_item_id || null,
        nomenclature_id: item.nomenclature_id,
        quantity: item.quantity,
        product_sheet_id: item.product_sheet_id || null,
      })),
    }),
  });
};

export const getTechnologicalCardsForNomenclature = async (divisionId, nomenclatureId) => {
  return await fetchWithAuth(`${API_URL}product-sheet/ready?division_id=${divisionId}&nomenclature_id=${nomenclatureId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};
